import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const EmailTemplates = lazy(() => import('./EmailTemplates'));
const EmailTemplatesListView = lazy(() => import('./components/views/EmailTemplatesListView'));
const EmailTemplateFormView = lazy(() => import('./components/views/EmailTemplateFormView'));

const EmailTemplatesRoute: FuseRouteItemType = {
	path: '/email-templates',
	element: <EmailTemplates />,
	children: [
		{
			path: '',
			element: <EmailTemplatesListView />
		},
		{
			path: 'new',
			element: <EmailTemplateFormView />
		},
		{
			path: ':id',
			element: <EmailTemplateFormView />
		}
	]
};

export default EmailTemplatesRoute;
